interface Translations {
  home: string;
  login: string;
  contacts: string;
  weatherPortal: string;
  weatherForecast: string;
  copyright: string;
  dailyForecast: string;
  meteorologicalPortal: string;
  weatherDescription: string;
  searchPlaceholder: string;
  forecastNextDays: string;
  summary: string;
  precipitation: string;
  wind: string;
  ChanceRain: string;
  temperature: string;
  humidity: string;
  weatherTrends: string;
  thermalSensation: string;
  sun: string;
  moon: string;
  airQualityIndex: string;
  weatherDetails: string;
  dailyHistoricalTemperature: string;
  dayForecast30: string;
  dailyMaximum: string;
  dailyMinimum: string;
  city: string;
  sunriseSunset: string;
  moonriseMoonset: string;
  info: string;
  lastmonths12: string;
  allyears: string;
  dailySummary12Months: string;
  max: string;
  avgr: string;
  min: string;
  hottestMonth: string;
  coldestMonth: string;
  wettestMonth: string;
  windiestMonth: string;
  highTemp: string;
  lowTemp: string;
  noData: string;
  sunny: string;
  cloudy: string;
  partly_cloud: string;
  rainy: string;
  partly_rainy: string;
  stormy: string;
  thunderstorm: string;
  unknown_weather: string;
}

const translations: Record<string, Translations> = {
  pt: {
    home: 'Início',
    login: 'Entrar',
    contacts: 'Contactos',
    weatherPortal: 'Portal Meteorológico',
    weatherForecast: 'Previsão do Tempo',
    copyright: 'INAM, Todos direitos reservados.',
    dailyForecast: 'Previsão do Tempo Diária',
    meteorologicalPortal: 'Portal de Informação Meteorológica',
    weatherDescription: 'Confira a previsão do tempo para hoje e tenha acesso a dados detalhados sobre temperatura, precipitação, umidade, ventos e  mais.',
    searchPlaceholder: 'Pesquisar localização',
    forecastNextDays: 'Previsão para os próximos dias',
    summary: 'Resumo',
    precipitation: 'Precipitação',
    wind: 'Vento',
    ChanceRain: 'Possibilidade de chuva',
    weatherTrends: 'Tendências meteorológicas',
    humidity: 'Humidade',
    temperature: 'Temperatura',
    thermalSensation: 'Sensação Térmica',
    sun: 'Sol',
    moon: 'Lua',
    airQualityIndex: 'Índice de Qualidade do Ar',
    weatherDetails: 'Detalhes de meteorologia',
    dailyMinimum: 'Mínima diária',
    dailyMaximum: 'Máxima diária',
    dayForecast30: 'Previsão de 30 dias',
    dailyHistoricalTemperature: 'Temperatura histórica diária',
    city: "Cidade",
    sunriseSunset: "Nascer & Pôr do Sol",
    moonriseMoonset: "Nascer & Pôr da Lua",
    info: "Informações sobre o clima",
    lastmonths12: "Últimos 12 meses",
    allyears: "Todos os Anos",
    dailySummary12Months: "Resumo Diário (Últimos 12 meses)",
    max: "Máx",
    avgr: "Média",
    min: "Min",
    hottestMonth: "Mês mais quente",
    coldestMonth: "Mês mais frio",
    wettestMonth: "Mês mais húmido",
    windiestMonth: "Mês mais ventoso",
    highTemp: "Temperatura elevada (°C)",
    lowTemp: "Temperatura baixa (°C)",
    noData: "Sem dados.",
    sunny: "Ensolarado",
    cloudy: "Nublado",
    partly_cloud: "Parcialmente Nublado",
    rainy: "Chuvoso",
    partly_rainy: "Parcialmente Chuvoso",
    stormy: "Tempestuoso",
    thunderstorm: "Trovoada",
    unknown_weather: "Clima Desconhecido"
  },
  en: {
    home: 'Home',
    login: 'Login',
    contacts: 'Contacts',
    weatherPortal: 'Weather Portal',
    weatherForecast: 'Weather Forecast',
    copyright: 'INAM, All rights reserved.',
    dailyForecast: 'Daily Weather Forecast',
    meteorologicalPortal: 'Meteorological Information Portal',
    weatherDescription: 'Check the weather forecast for today and get detailed information about temperature, precipitation and more.',
    searchPlaceholder: 'Search location',
    forecastNextDays: 'Forecast for the next 10 days',
    summary: 'Summary',
    precipitation: 'Precipitation',
    wind: 'Wind',
    ChanceRain: 'Chance of rain',
    weatherTrends: 'Weather Trends',
    humidity: 'Humidity',
    temperature: 'Temperature',
    thermalSensation: 'Thermal sensation',
    moon: 'Moon',
    sun: 'Sun',
    airQualityIndex: 'Air Quality Index',
    weatherDetails: 'Weather details',
    dailyMinimum: 'Daily minimum',
    dailyMaximum: 'Daily maximum',
    dayForecast30: '30 day forecast',
    dailyHistoricalTemperature: 'Daily historical temperature',
    city: "City",
    sunriseSunset: "Sunrise & Sunset",
    moonriseMoonset: "Moonrise & Moonset",
    info: "Weather Information",
    lastmonths12: "Last 12 Months",
    allyears: "All Years",
    dailySummary12Months: "Daily Summary (Last 12 Months)",
    max: "Max",
    avgr: "Average",
    min: "Min",
    hottestMonth: "Hottest Month",
    coldestMonth: "Coldest Month",
    wettestMonth: "Wettest Month",
    windiestMonth: "Windiest Month",
    highTemp: "High Temperature (°C)",
    lowTemp: "Low Temperature (°C)",
    noData: "No data to display.",
    sunny: "Sunny",
    cloudy: "Cloudy",
    partly_cloud: "Partly Cloudy",
    rainy: "Rainy",
    partly_rainy: "Partly Rainy",
    stormy: "Stormy",
    thunderstorm: "Thunderstorm",
    unknown_weather: "Unknown Weather"
  }
};

export default translations;
